import React from 'react';
import PropTypes from 'prop-types';

export const FxTextLink = ({ text, onTextClick }) => (
  <span
    className="dls-bright-blue icon-link icon-hover"
    tabIndex="0"
    role="button"
    onKeyPress={onTextClick}
    onClick={onTextClick}
  >
    {text}
  </span>
);

FxTextLink.propTypes = {
  text: PropTypes.string.isRequired,
  onTextClick: PropTypes.func,
};

FxTextLink.defaultProps = {
  onTextClick: null,
};
